import { useRef, useMemo } from 'react';
import fractionStringToDecimal from '../fractionStringToDecimal';
export default _ref => {
  let {
    chevronScrollAmount = '1/10',
    additionalPixels = 0,
    isDefaultScrollDirection = false
  } = _ref;
  const containerRef = useRef(null);
  const scrollFactor = useMemo(() => fractionStringToDecimal(chevronScrollAmount), [chevronScrollAmount]);
  const scroll = direction => {
    const content = containerRef.current;
    if (content) {
      const directionMultiplier = direction === 'right' ? 1 : -1;
      const scrollAmount = directionMultiplier * (content.scrollWidth * scrollFactor + additionalPixels);
      content.scrollLeft += scrollAmount;
    }
  };
  const scrollDefault = direction => {
    const content = containerRef.current;
    if (isDefaultScrollDirection && content) {
      content.scrollLeft = direction === 'left' ? 0 : content.scrollWidth;
    }
  };
  return [containerRef, scroll, scrollDefault];
};
//# sourceMappingURL=index.js.map